
<div class="popup-model popup-lg shadow top">
  <div class="d-flex justify-content-between align-items-center pink-header P-2">
    <h5 class="flex-grow-1 text-center mt-1">{{ 'DELIVERY.MODIFY_LOAD' | translate }}</h5>
    <div data-svg-wrapper style="position: relative" class="p-1">
      <button class="btn p-0 d-flex align-items-center" (click)="close()">
        <img src="assets/icon/close.svg" />
      </button>
    </div>
  </div>
  <div class="p-4 scrollable-container">
    <div class="d-flex justify-content-left m-2" style="gap: 20px;">
      <button class="btn p-0 d-flex align-items-center" (click)="setTab('delivery')">
        <span [ngClass]="{'highlighted-div': selectedTab() === 'delivery'}">{{ 'DELIVERY.DELIVERY' | translate }}</span>
      </button>

      <button class="btn p-0 d-flex align-items-center" (click)="setTab('holes')">
        <span [ngClass]="{'highlighted-div': selectedTab() === 'holes'}">{{ 'DELIVERY.HOLES' | translate }}</span>
      </button>
    </div>

    @if (deliveryParams()) {
      <div>
        <div [ngStyle]="{ display: selectedTab() === 'delivery' ? 'block' : 'none' }"
          style="margin-top: 1.5rem; padding: 1rem;">
          <app-modify-load [form]="$any(modifyLoadForm.get('deliveryForm'))" [deliveryParams]="deliveryParams()"
            [currentSiteId]="currentSiteId()"
            [currentDelivery]="jsonDelivery"
            [blastId]="delivery.tirId"
            (moveDelivery)="moveDelivery($event)"
            (updateDelivery)="submit()"
            (mergeDelivery)="mergeDeliveries($event)"
          (close)="close()"></app-modify-load>
        </div>
        <div [ngStyle]="{ display: selectedTab() === 'holes' ? 'block' : 'none' }" style="margin-top: 1.5rem;">
          <app-modify-hole [holesDeliveryControl]="$any(modifyLoadForm.get('holesDeliveryForm'))"
            [deliveryParams]="deliveryParams()"
            [totalHolesCount]="allHoles().length"
            [currentLoadedCount]="currentLoadedCount()"
            [isScrollLoading]="isLoading()"
            (splitDelivery)="splitDelivery($event)"
            (updateDelivery)="submit($event)"
          (loadMoreHoles)="loadMoreHoles()"></app-modify-hole>
        </div>
      </div>
    }
  </div>
</div>
